<script setup lang="ts">
defineProps<{
    result: string
    error?: string
}>()
</script>

<template>
    <div
        v-if="error"
        class="rounded-2xl border border-amber-500 bg-amber-500/20 px-4 py-4 text-center font-medium text-amber-950 dark:text-amber-100"
    >
        {{ error }}
    </div>

    <div
        v-else-if="result"
        class="rounded-2xl border border-green-500 bg-green-500/30 px-4 py-4 text-center font-medium text-green-950 dark:text-green-100"
    >
        <p v-html="result" />
    </div>
</template>
